;(function() {
  'use strict'

  angular.module('app.core').component('matchTokens', {
    templateUrl: 'match-tokens.html',
    bindings: {
      tokens: '<',
    },
  })
})()
